<template>
  <div class="all_print">
    <div class="print_header">{{ data_header }}</div>
    <!-- <div class="product">{{ table_data[0].supplier}}</div> -->
    <div class="print_nav">
      <div>制单时间：{{ createTime }}</div>
      <div>供应单位：{{ supplier }}</div>
      <div>送货单编号：{{ searchobj.formId }}</div>
    </div>
    <div>
      <canvas class="draw_barcode" ref="barcodeCanvas"></canvas>
    </div>
    <table class="print_body">
      <thead>
        <tr>
          <td>序号</td>
          <td>采购人</td>
          <td>合同号</td>
          <td>物料名称</td>
          <td>型号</td>
          <!-- <td>品名规格</td> -->
          <td>备注</td>
          <td>物料编码</td>
          <td>单位</td>
          <td>数量</td>
          <td>单价</td>
          <td>金额</td>
        </tr>
      </thead>
      <tbody v-if="table_data">
        <tr v-for="(item, index) in table_data" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td>{{ maskName(item.purchaserName ?? '') }}</td>
          <td>{{ item.trackNumber }}</td>
          <td>{{ item.materialName }}</td>
          <td>{{ item.materialType }}</td>
          <td>{{ item.itemRemark }}</td>
          <td>{{ item.materialBarcode }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.outputNumber }}</td>
          <td>{{ item.price }}</td>
          <td>{{ item.totalPrice }}</td>
        </tr>
      </tbody>
    </table>
    <div style="display: flex;padding-top: 10px;justify-content: space-between;">
      <div>收货单位：{{ company }}</div>
      <div>合计：{{ totalPrice }}（元）</div>
    </div>
    <div style="display: flex;padding-top: 10px;justify-content: space-between;">
      <div>收货地址：{{ deliveryAddress }}</div>
    </div>
    <div class="print_footer">
      <div>收货人：</div>
      <div>送货人：</div>
      <div style="margin-right: 60px;">发货人：</div>
    </div>
  </div>
</template>
<style scoped>
.all_print {
  font-family: "Times New Roman", Times, serif;
  color: #000;
  font-size: 13px;
  position: relative;
}

.product {
  position: absolute;
  top: 43px;
  /* left: 20px; */
  font-size: 15px;
}

.draw_barcode {
  position: absolute;
  right: 0;
  top: -60px;
  width: 200px;
}

.print_header {
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  font-weight: bold;

  /* color: #000; */
}

.print_nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 10px; */
  border-radius: 5px;
  height: 20px;
  padding: 0px 20px 0px 20px;
  /* color: #000; */
}

.print_body {
  text-align: center;

}

table {
  width: 100%;
  /* margin: 10px; */
  border-collapse: collapse;
  margin: 0 auto
}

th,
td {
  border: 1px solid #000;
  border-collapse: collapse;
  padding: 8px 5px
}

thead {
  border: none;
}

thead tr {
  border: none;
}

thead tr th {
  border: none;
  border-collapse: separate;
}

/* .print_table, .print_table ::v-deep th{
    color: #000000;
} */

/* 边框样式 */
.print_table ::v-deep td,
.userTablth.is-leaf {
  border-bottom: 1px solid #000000;
  border-right: 1px solid #000000;
}

.print_table ::v-deep td,
.print_table ::v-deep th.is-leaf {
  border-bottom: 1px solid #000000;
  border-right: 1px solid #000000;
}

.print_table ::v-deep .el-table--border,
.print_table ::v-deep .el-table--group {
  border: 1px solid #000000;
}


.print_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 5px;
  height: 40px;
  padding: 0 20px;
  color: #000;
}

/* @page {
  size: A4 landscape;
} */

@media print {

  /* .print_body {
    table-layout: fixed;
     page-break-inside: avoid; 
  } */
  table {
    width: 99%;
    table-layout: auto;
  }

  thead {
    display: table-row-group;
    /* 表头作为一个整体显示 */
  }

  tbody {
    display: table-row-group;
    /* 表体作为一个整体显示 */
  }

  tr {
    page-break-inside: avoid;
  }
}
</style>
<script>
import * as sentFormApi from '@/Api/sentFormApi.js'
import JsBarcode from 'jsbarcode';
export default {
  data() {
    return {
      data_header: '送货单',
      // data_row: [],
      searchobj: {
        pageSize: 1000,
        currentPage: 1,
      },
      header: {
        headers: { token: sessionStorage.getItem('token') }
      },
      table_data: [],
      totalPage: '',
      createTime: '',
      supplier: '',
      totalPrice: '',
      company: this.$store.state.companyId == 'LFWZ' ? '广东凌丰五金装备科技股份有限公司' :
        this.$store.state.companyId == 'NTLD' ? '南通立德装备科技有限公司' : '',
      deliveryAddress: '',
    }
  },
  mounted() {
    this.generateBarcode();
  },
  methods: {
    maskName(name) {
      if (!name) return '';
      if (name.length <= 1) return name;
      // const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      // let masked = '';
      // for (let i = 0; i < name.length - 1; i++) {
      //   masked += letters[i % letters.length];
      // }
      return name[name.length - 1];
    },
    generateBarcode() {
      JsBarcode(this.$refs.barcodeCanvas, this.searchobj.formId, {
        format: 'CODE128', // 条形码格式，可以根据需求选择其他格式
        displayValue: false, // 是否在条形码下方显示文本

        // marginTop: 5,        // 取消顶部默认边距
        marginBottom: 5,     // 取消底部默认边距
      });
    },
    senior_search() {
      sentFormApi.sentFormQuery(this.searchobj, this).then(res => {
        let records = res.records;
        records.forEach(item => {
          if (item.itemRemark && (item.itemRemark.includes('http://') || item.itemRemark.includes('https://'))) {
            item.itemRemark = ''; // 清空网址备注
          }
        });
        this.table_data = records; // 使用过滤后的数据
        this.deliveryAddress = records.find(item => item.deliveryAddress != null)?.deliveryAddress
        this.totalPage = res.total
        sentFormApi.searchAllSentForm({ pageSize: 1, currentPage: 1, formId: this.searchobj.formId }, this).then(res2 => {
          this.createTime = res2.records[0].createDate
          this.supplier = res2.records[0].supplierName
          this.totalPrice = res2.records[0].totalPrice
          setTimeout(() => {
            window.print()
          }, 100)
        }).catch(() => { })
      }).catch(() => { })
    },
  },
  created() {
    if (this.$route.query.check_status == 2) {
      console.log(this.$route.query.check_list);
      this.searchobj.formId = this.$route.query.check_list
      this.senior_search()
    }
  }
}
</script>